<template>
  <div class="card box-shadow shadow">
    <div class="card-header">
      <h5 class="mb-0">
        <button class="btn btn-link" type="button" @click.prevent="toggle">
          {{ question }}
        </button>
      </h5>
    </div>
    <div class="collapse" :class="{ 'show': isOpen }">
      <div class="card-body">
        <p v-for="(text, index) in answer" :key="index + 1">
          {{ text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: String,
    answer: Array
  },
  data: () => ({
    isOpen: false
  }),
  methods: {
    toggle () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
